FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="number"]';
    var PARENT = '[data-parent="true"]';
    var eventsAreSet = false;


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 55,
        value: '',

        initial: '',
        max: 10000000000000,            //  max value of number
        min: -10000000000000,           //  min value of number
        precision: null,                //  number of digits to show after decimal point
        reset: 'zero',                  //  zero, initial
        comma: true,                    //  use comma on display
        focus: false,                   // set focus
        allownull: false,
        noedit: false,
        clearonload: false,
        islocked: false
    };



    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set events
        $(document).off('focus blur keyup keydown', ELEM)
            .on('focus.' + NAMESPACE, ELEM, setFocus)
            .on('blur.' + NAMESPACE, ELEM, setValidate)
            .on('keyup.' + NAMESPACE, ELEM, function (event) {
                var e = $(this);
                var data = e.data();

                //  esc
                if (event.which === 27 || event.keyCode === 27) {
                    e.val(data.initial);
                    me.setInputFocus(e, true);
                    return;
                }

                // Prevent Blur() on excel-navigation or the table will lose track fo it's location.
                if (e.closest(".excel-navigation").length > 0)
                    return;
                //  enter
                if (event.which === 13 || event.keyCode === 13) {
                    e.blur();
                }
            })
            .on('keydown.' + NAMESPACE, ELEM, function (event) {
                var e = $(this);
                var data = e.data();

                //  data locked
                if (data.islocked) {
                    return false;
                }

                // Allow: backspace, delete, tab, escape, enter and shift.
                if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 110, 190, 16]) !== -1 ||
                    // Allow: Ctrl/cmd+A
                    (event.keyCode === 65 && (event.ctrlKey === true || event.metaKey === true)) ||
                    // Allow: Ctrl/cmd+C
                    (event.keyCode === 67 && (event.ctrlKey === true || event.metaKey === true)) ||
                    // Allow: Ctrl/cmd+X
                    (event.keyCode === 88 && (event.ctrlKey === true || event.metaKey === true)) ||
                    // Allow: Ctrl/cmd+V
                    (event.keyCode === 86 && (event.ctrlKey === true || event.metaKey === true)) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }

                // Ensure that it is a number and stop the keypress //   - key
                if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                    if ((event.keyCode === 173 || event.keyCode === 109 || event.keyCode === 189)) {
                        return;
                    }
                    event.preventDefault();
                }
            });
    }


    //  get number 
    function getNumber(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        //  wire events
        if (wireEvent && !eventsAreSet) {
            setEvents();
            eventsAreSet = true;
        }

        //  bail
        if (list.length === 0) {
            return;
        }

        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());
            if (options.clearonload) {
                options.clearonload = false;
                elem.val(elem.attr('data-initial')).attr('data-clearonload', false);
            }

            //  set islocked (used in FOX, for focus event)
            options.islocked = options.islocked || false;

            //  set elem data
            var PARENT = '[data-parent="true"]';
            var targetElm = options.useparent ? elem.closest(PARENT) : elem;
            var targetData = {};
            if (targetElm.length) {
                targetData = targetElm.data();
            }

            // udpate data
            options.callback = me.setCallBackPrefix(targetData.callbackprefix);
            options.parentid = targetData.parentid || 0;           

            //  set data
            elem.data(options);

            //  no edit
            if (options.noedit) {
                elem.attr('readonly', true);
            }

            //  reset
            setReset(elem);
        });
    }


    //  set focus
    function setFocus() {
        var elem = $(this);
        var data = elem.data();
        if (document.isUndo) {
            document.isUndo = false;
            return;
        }
        if (data.noedit) {
            return;
        }

        if (data.allownull && elem.val() === '') {
            data.initial = null;
        } else {
            data.initial = (new Number(elem.val().replace(/[^0-9\.\-]+/g, ""))).valueOf();
        }

        if (data.islocked) {
            elem.val(me.getLabel().Locked);
        }

        if (data.focus) {
            elem.select();
        }
    }


    //  set reset
    function setReset(e) {
        var data = e.data();
        var value = e.val();
        var isnull = false;

        //  remove comma
        value = me.setNoComma(value);


        if (value === '' && data.allownull) {
            value = null;
            e.data('value', null);
        } else {
            value = new Number(value);

            if (isNaN(value)) {
                value = isNaN(+e.data('initial')) ? new Number() : +e.data('initial');
            }

            if (value < data.min) {
                value = data.min;
            } else if (value > data.max) {
                value = data.max;
            }

            if (data.precision !== null && +data.precision >= 0) {
                value = value.toFixed(data.precision);
            }

            e.data('value', value);

            if (data.comma) {
                value = me.setComma(value);
            }
        }

        e.val(value);
    }


    //  set validate
    function setValidate() {
        var e = $(this);
        var data = e.data();

        setReset(e);

        if (data.noedit) {
            return;
        } else if (data.islocked) {
            return;
        }

        setCallback(e);
    }


    //  set callback
    function setCallback(elem) {
        var data = elem.data();

        if (data.value === null) {
            if (data.initial === null) {
                return;
            }
        } else if (+data.value === data.initial) {
            return
        }

        var val = data.value === null ? null : data.value.valueOf();

        me.setCallBackFromData(elem, { e: elem, value: val, initial: data.initial, tag: data.tag, parentid: data.parentid });
        elem.data('initial', data.value);
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  set number
    child.setNumber = function (wireEvent, container) {
        getNumber(wireEvent, container);
    };



    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));